import { Component, EventEmitter, Input, Output } from '@angular/core';
import {PhoneEnrollmentCompletedEvent,PhoneEnrollmentContext} from '@krediya/enrollment';

@Component({
  selector: 'app-sales-phone-enrollment-library',
  templateUrl: './sales-phone-enrollment-library.component.html',
  styleUrls: ['./sales-phone-enrollment-library.component.scss']
})
export class SalesPhoneEnrollmentLibraryComponent {
  @Input() enrollmentContext?: PhoneEnrollmentContext;
  @Output() enrollmentCompletedEvent = new EventEmitter<PhoneEnrollmentCompletedEvent>();

  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Guía de enrolamiento'];

  onCompleted(event: PhoneEnrollmentCompletedEvent): void {
    console.log('[Enrollment library] completed', event);
    this.enrollmentCompletedEvent.emit(event);
  }
}
